{
  "meta": {
    "title": "宋明轩",
    "description": "宋明轩 — 北京大学博士研究生。研究方向：强化学习、分片区块链和大语言模型；欢迎实习和合作机会。"
  },
  "nav": {
    "home": "🏠 首页",
    "chinese": "🌏 中文",
    "english": "🌏 English",
    "about": "👦🏻 关于我",
    "publications": "📚 论文成果",
    "news": "📰 新闻动态",
    "projects": "🌟 项目",
    "friends": "🧑‍🤝‍🧑 朋友们",
    "contact": "✉️ 联系方式"
  },
  "hero": {
    "title": "你好，我是 <span class=\"text-color-main\">宋明轩</span> ~",
    "subtitle": "我目前在 <span class=\"text-color-main\">北京大学</span> 计算机学院攻读计算机系统结构专业理学博士学位，师从<span class=\"text-color-main\">肖臻</span>研究员。",
    "cta": "了解更多",
    "messageForm": {
      "title": "给我发一条消息",
      "namePlaceholder": "你的名字（可选）",
      "emailPlaceholder": "你的邮箱（可选）",
      "messagePlaceholder": "想对我说的话...",
      "submit": "发送"
    }
  },
  "about": {
    "title": "关于我",
    "text1": "我目前是北京大学计算机学院2023级计算机系统结构专业的博士研究生，预计2028年6月毕业。我本科于2023年6月毕业自中国地质大学（武汉）计算机学院计算机科学与技术专业。我的研究兴趣包括强化学习（RL）、大语言模型（LLMs）以及分片区块链。欢迎联系我交流！",
    "text2": "我喜欢打台球、羽毛球、乒乓球，也热爱跑步。我的目标是在不断提升专业能力的同时，保持健康充实的生活方式。我始终相信，一个人的成长不仅仅体现在知识和技能的积累上，更在于如何在繁忙的工作中找到属于自己的节奏，明白自己真正想要的是什么，而不是迷失在内卷的环境下。",
    "location": "📍 所在地：北京，中国",
    "hobbies": "🎯 爱好：🎱 台球 | 🏸 羽毛球 | 🏓 乒乓球 | 🏃‍♂️ 跑步",
    "viewResume": "查看简历",
    "resumeUrl": "./assets/resumeCN.pdf"
  },
  "publications": {
    "title": "📚 论文成果",
    "scholar": "Scholar",
    "firstAuthor": "第一作者",
    "others": "其他"
  },
  "news": {
    "title": "📰 新闻动态",
    "items": [
      {
        "text": "我们的论文《DARA: Few-shot Budget Allocation in Online Advertising via In-Context Decision Making with RL-Finetuned LLMs》被 WWW 2026 接收为 Oral 报告，阿里妈妈技术发布专题报道。",
        "report": "[报道]",
        "date": "2026年5月7日"
      },
      {
        "text": "北京大学计算机学院组织的上海暑期实践活动。",
        "report": "[报道]",
        "date": "2025年8月29日"
      },
      {
        "text": "北京大学计算机学院组织的安徽省合肥市暑期实践活动。",
        "report1": "[报道1]",
        "date1": "2025年7月30日",
        "report2": "[报道2]",
        "date2": "2025年8月5日"
      },
      {
        "text": "「小北课后辅导」第一期：作为课程助教，讲解计算机中基础而重要的知识点——递归。",
        "video": "[视频]",
        "date": "2025年3月18日"
      },
      {
        "text": "北京大学十院联合计算概论课程成功举办。",
        "report": "[报道]",
        "date1": "2024年12月23日",
        "preview": "[预告]",
        "date2": "2024年12月12日"
      },
      {
        "text": "北京大学计算机学院组织的四川省绵阳市暑期实践活动。",
        "report": "[报道]",
        "date": "2024年7月19日"
      },
      {
        "text": "中国地质大学（武汉）2023届优秀本科毕业生。",
        "link": "[链接]",
        "date": "2023年6月19日"
      },
      {
        "text": "北京大学2023年推荐免试研究生公示名单，北京大学。",
        "link": "[链接]",
        "date": "2022年11月1日"
      },
      {
        "text": "中国地质大学（武汉）计算机学院第二届专业纵向交流论坛。",
        "link": "[链接]",
        "date": "2022年10月3日"
      },
      {
        "text": "北京大学计算机学院2022年优秀大学生夏令营。",
        "admissionResult": "[录取结果]",
        "date1": "2022年9月30日",
        "outstandingList": "[优秀营员名单]",
        "date2": "2022年7月8日",
        "admissionNotice": "[录取通知]",
        "date3": "2022年6月28日"
      },
      {
        "text": "中国地质大学（武汉）计算机学院第二届专业纵向交流论坛。",
        "link": "[链接]",
        "date": "2022年9月27日"
      },
      {
        "text": "中国地质大学（武汉）计算机学院111003班优秀学生奖学金。",
        "link": "[链接]",
        "date": "2022年6月21日"
      },
      {
        "text": "2021年全国大学生数学建模竞赛（MCM杯）获奖名单。",
        "link": "[链接]",
        "date": "2021年11月15日"
      },
      {
        "text": "国家级大学生创新创业训练计划平台。",
        "link": "[链接]",
        "date": "2021年8月24日"
      },
      {
        "text": "中国地质大学（武汉）本科生国家奖学金候选人公示名单（2019-2020学年）。",
        "link": "[链接]",
        "date": "2020年11月2日"
      }
    ]
  },
  "projects": {
    "title": "🌟 项目",
    "project1": {
      "title": "面向大语言模型的小样本强化学习微调",
      "affiliations": "所属单位：",
      "affiliation1": "北京大学计算机学院；",
      "affiliation2": "阿里巴巴集团阿里妈妈广告团队。",
      "description": "近年来，大语言模型（LLMs）在多种自然语言处理任务中展现出卓越性能。但传统微调方法往往依赖大规模数据集与高算力资源，限制了其在小样本与预算受限场景中的应用。本项目提出了一种新颖的少样本强化学习微调方法，旨在利用最少的监督信息将预训练模型高效适配至特定任务。"
    },
    "project2": {
      "title": "强化学习驱动的高效分片区块链系统",
      "affiliations": "所属单位：",
      "affiliation1": "北京大学计算机学院；",
      "affiliation2": "Theta 实验室，Theta 公司。",
      "description": "分片区块链在跨片数据传输效率和工作负载均衡方面面临重大挑战。传统地址分配机制在交易模式频繁变动和系统重构场景下，常导致延迟高、分片利用率不均。本项目提出一种强化学习方案，优化地址分布与迁移策略，以提升系统整体吞吐与负载均衡性。"
    },
    "project3": {
      "title": "供水网络中传感器布局的进化强化学习",
      "affiliations": "所属单位：",
      "affiliation1": "中国地质大学（武汉）计算机学院。",
      "description": "在供水网络中，有效的传感器布局对于早期检测污染事件至关重要，然而实际部署受到有限的传感器预算和稀缺的历史污染数据的限制。本研究将传感器布局问题建模为有限监督下的序贯决策过程，提出了一种进化强化学习方法。通过将领域知识融入进化强化学习框架，所提出的方法能够实现高效优化。"
    }
  },
  "friends": {
    "title": "🧑‍🤝‍🧑 朋友们"
  },
  "contact": {
    "title": "✉️ 联系方式",
    "email": "✉️ 邮箱: songmingxuan@stu.pku.edu.cn",
    "wechat": "💬 微信: smx-scholar",
    "cta": "Call to Action"
  },
  "footer": {
    "text": "© 2025 - Developed by Mingxuan Song"
  },
  "stats": {
    "title": "📊 访问统计",
    "today": "今日访问:",
    "total": "总访问量:",
    "tabRegions": "访问地区分布",
    "tabMap": "访问地图",
    "regions": "访问地区分布:",
    "map": "访问地图:",
    "mapScope": "仅展示最近 3 个月的访问点位。",
    "mapNote": "提示：中国大陆地区可能无法访问地图瓦片，系统会自动切换为简化底图。"
  }
}
